/// <amd-module name="Repos/Tfvc/Views/ChangeDetails/Components/ChangeDetailsTab" />
import { MarkdownPreviewWithAutocomplete } from "Mention/MarkdownWithAutocomplete/Components";
import * as React from "react";
import { previewOptions } from "Repos/Discussion/Utils/Markdown";
import * as Resources from "Repos/Tfvc/Views/ChangeDetails/Resources";
import { IRegionComponentProperties, WrappedComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { useChangeDetailsContext } from "../ChangeDetailsContext";

export const ChangeDetailsTab = (): JSX.Element => {
    const { viewService } = useChangeDetailsContext();
    const message = viewService.getChangeFullComment();

    return (
        <div className="rhythm-vertical-16">
            <Card titleProps={{ text: Resources.DescriptionTitle, ariaLevel: 2 }}>
                <MarkdownPreviewWithAutocomplete value={message} options={previewOptions} />
            </Card>
            <ChangeDetailsExtensions />
        </div>
    );
};

export const ChangeDetailsExtensions = (): JSX.Element => {
    const { extensionContext } = useChangeDetailsContext();
    const { childComponentProperties, componentRegion, dependencies } = extensionContext;

    return (
        <WrappedComponent<IRegionComponentProperties>
            dependencies={dependencies}
            wrappedType="ms.vss-web.region"
            wrappedProps={{
                childComponentProperties,
                className: "rhythm-vertical-16",
                componentRegion
            }}
        />
    );
};
